/* DON'T EDIT THIS FILE: edit original and run build again */ export const colorSchemeProperties = [
  "primary", // Accent color
  "secondary", // Hover color, darker than primary
  "tertiary", // Background color for login/register pages
] as const;
type ColorSchemeKeyType = (typeof colorSchemeProperties)[number];
export type FullColorScheme = Record<ColorSchemeKeyType, string>;
export type ColorScheme = Partial<FullColorScheme>;
